import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const MedicalHistory = () => {

    return (
        <><PatientAction />
        <form>
            <div className="MedicalHistory-info" >
                <div className="mt-3 ml-4"> <h4>Medical History</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0, marginTop: 20 }}>
                <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Any Surgery / Previous hospitalization:</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Any Surgery / Previous hospitalization:" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Diabetes</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Diabetes" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm"> High Blood Pressure</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder=" High Blood Pressure" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Asthma</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Asthma" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Heart Disease</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="BHeart Disease" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Thyroid</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Thyroid" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Cancer</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Cancer" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Any other</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Any other" />
                        </div>
                    </div>
                   
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default MedicalHistory ; 

